import { useState, useRef, useEffect } from 'react';

import { useDispatch, useSelector } from 'react-redux';
import {
	updateClient,
	updateClientNotes,
	fetchClients,
	fetchClientById,
	deleteClient,
} from '../../slices/clientSlice';
import { fetchSelf, fetchUsers } from '../../slices/userSlice';
import { useForm } from 'react-hook-form';
import { formatPhoneNumberInput, formatPhoneNumber } from '../../hooks/phoneFormat';
import {
	ChevronDown,
	ChevronRight,
	Edit2,
	Edit,
	Trash2,
	Download,
	PlusCircle,
	X,
	Phone,
	FileText,
	Mail,
	XCircle,
	PhoneOutgoing,
} from 'react-feather';
import axios from 'axios';
import usePopup from '../../hooks/popuphook';
import FileViewerModal from '../modals/FileViewerModal';
import { normalizeClientAddress } from '../../utils/addressUtils';

export default function ClientDetails({ onClose, selectedClient, closeSlide }) {
	const dispatch = useDispatch();
	const currentUser = useSelector((state) => state.auth.self);
	const usersList = useSelector((state) => state.auth?.users);

	// if current user and userList.id is the same return the user name userlist.name
	const getUserName = (userId) => {
		console.log('selectedClient', usersList);
		if (!usersList || usersList.length === 0 || !userId) {
			return 'Unknown';
		}

		const user = usersList.find(
			(user) => user?.id?.trim().toLowerCase() === userId.trim().toLowerCase()
		);

		return user ? user?.firstName + ' ' + user?.lastName : 'Unknown';
	};

	// popup
	const { isOpen, openPopup, closePopup } = usePopup();
	const [editFrom, setEditForm] = useState(false);
	const api = process.env.REACT_APP_API_URL;
	const formRef = useRef();
	const [sections, setSections] = useState({
		info: false,
		address: false,
		notes: false,
	});
	const {
		register,
		handleSubmit,
		setValue,
		reset,
		watch,
		formState: { errors },
	} = useForm();

	const pageSize = 100;

	// toggle secctions
	const toggleSection = (section) => {
		setSections((prevSections) => ({
			...prevSections,
			[section]: !prevSections[section],
		}));
	};

	// clean up the code
	const client = useSelector((state) => state.clients.clientById);
	const clientAddress = normalizeClientAddress(client);
	// option for status
	const statusOptions = [
		{ value: 1, label: 'Waiting', color: 'bg-yellow-300' },
		{ value: 2, label: 'Ok', color: 'bg-green-500' },
		{ value: 3, label: 'Blocked', color: 'bg-red-500' },
	];

	// Status display
	const getStatusLabel = (status) => {
		const option = statusOptions.find((option) => option.value === status);
		return option ? option.label : 'Unknown';
	};

	const getStatusColor = (status) => {
		const option = statusOptions.find((option) => option.value === status);
		return option ? option.color : 'bg-gray-500';
	};

	// account manager
	const accountManager = usersList
		?.filter((user) => !user?.email.includes('_deactivate_'))
		.map((user) => ({
			// label: user.firstName + ' ' + user.lastName,
			value: user.id,
			label: user.firstName + ' ' + user.lastName,
		}));

	// read the users and set the account manager value to the user id and label to the user name from

	//  add more fileds to upload file
	const [fileInputs, setFileInputs] = useState([0]);
	// sending files
	const existingNotes = client?.notes || [];
	// here is the file url
	const [urlState, setUrlState] = useState([]);
	const [newNoteText, setNewNoteText] = useState('');
	// Uploading progress bar
	const [Msg, setMsg] = useState(null);
	const [progress, setProgress] = useState({ started: false, pc: 0, msg: '' });

    // File Viewing
    const [viewerOpen, setViewerOpen] = useState(false);
    const [selectedFile, setSelectedFile] = useState(null);

	// pendding to clean up

	// clean functions

	// upload and remove inputs
	const addFileInput = () => {
		setFileInputs([...fileInputs, fileInputs.length]);
	};
	const removeFileInput = () => {
		if (fileInputs.length > 1) {
			const newFileInputs = fileInputs.slice(0, -1);
			setFileInputs(newFileInputs);
		}
	};

	// upload file
	const fileUploadHandler = async (file) => {
		const token = localStorage.getItem('token');

		// upload file by file and wait for the response to copy the url
		const formData = new FormData();
		if (file) {
			// Create a new File object with the same file data but a modified name
			const newFile = new File([file], file.name.replace(/\s/g, '_'), {
				type: file.type,
			});

			formData.append('file', newFile);

			setMsg('Uploading...');
			setProgress({ started: true, pc: 0, msg: 'Uploading...' });
		}

		try {
			const response = await axios.post(`${api}/files/upload`, formData, {
				onUploadProgress: (progressEvent) => {
					const pc = Math.round(
						(progressEvent.loaded / progressEvent.total) * 100
					);
					setProgress({ started: true, pc, msg: 'Uploading...' });
				},
				headers: {
					'Content-Type': 'multipart/form-data',
					Authorization: `Bearer ${token}`,
				},
			});

			// Store object with url, name, and type
			setUrlState([
                ...urlState, 
                {
                    url: response.data.fileUrl,
                    name: file.name,
                    type: file.type
                }
            ]);
			setMsg('File uploaded successfully!');
			setProgress({
				started: false,
				pc: 0,
				msg: 'File uploaded successfully ready to send or add more files!',
			});
		} catch (error) {
			setMsg('Error uploading file!');
		}
	};

	const onSubmitFile = async (data) => {
		// Check if newText is not empty
		const newNote = {
			userId: currentUser.id,
			createdAt: new Date().toISOString(),
			text: data.textNote,
			attachments: urlState.map((fileObj) => ({
				description: fileObj.name || 'Attachment', // Use preserved filename
				url: fileObj.url, 
                type: fileObj.type
			})),
		};

		// Add the new note to the existing notes
		const newNotes = [...existingNotes, newNote];

		// dispatch the action to update the notes
		await dispatch(
			updateClientNotes({
				id: selectedClient,
				notes: newNotes,
			})
		);
		// Clear the input fields
		dispatch(fetchClients(pageSize));
		setNewNoteText('');
		setUrlState([]);

		reset({
			textNote: '',
		});
		// Clear file inputs
		setFileInputs([0]);

		// Reset the form to clear the file input
		// Reset the form to clear the file input
		if (formRef.current) {
			formRef.current.reset();
		}

		dispatch(fetchClientById(selectedClient));
	};

	const onDeleteSubmit = (data) => {
		openPopup(data.id);
	};

	// delete client
	const handleDelete = async (id) => {
		console.log('delete', id);
		await dispatch(deleteClient(id));
		dispatch(fetchClients(pageSize));
		localStorage.removeItem('clientId');
		closePopup();
		onClose();
	};

		const watchedPhoneNumber = watch('phoneNumber');

		// Removed local formatPhoneNumber function to use the strict one from hooks
		const [phoneNumber, setPhoneNumber] = useState(client?.phoneNumber || '');

		// Hydrate user list once (used for account manager labels, notes attribution, etc.)
		useEffect(() => {
			if (!usersList || usersList.length === 0) {
				dispatch(fetchUsers({ pageSize: 100 }));
			}
	}, [dispatch, usersList]);

	// Keep local phoneNumber state in sync without re-fetching network resources.
	useEffect(() => {
		const formattedPhoneNumber = formatPhoneNumberInput(watchedPhoneNumber);
		if (formattedPhoneNumber !== phoneNumber) {
			setPhoneNumber(formattedPhoneNumber);
		}
	}, [phoneNumber, watchedPhoneNumber]);

	// Initialize phoneNumber when switching between clients.
		useEffect(() => {
			setPhoneNumber(formatPhoneNumberInput(client?.phoneNumber || ''));
		}, [client?.id]);

		const [isSaving, setIsSaving] = useState(false);
		const [hasError, setHasError] = useState(false);
		const [isSaved, setIsSaved] = useState(false);

	// update client info
	const onSubmit = async (data) => {
		setIsSaving(false);
		setHasError(false);
		setIsSaved(false);

		const cleanedPhoneNumber = (phoneNumber || '').replace(/\D/g, '');
		try {
			await dispatch(
				updateClient({
					id: selectedClient,
					firstName: data.firstName,
					lastName: data.lastName,
					companyName: data.companyName,
					email: data.email,
					phoneNumber: cleanedPhoneNumber,
					source: data.source,
					address: {
						address: data.address,
						city: data.city,
						state: data.state,
						postalCode: data.postalCode,
					},
					status: Number(data.status),
					active: true,
				})
			);

			dispatch(fetchClientById(selectedClient));
			dispatch(fetchClients({ pageSize: 100 }));
			setNewNoteText('');

			// Also clear the file inputs
			setFileInputs([0]);
			setIsSaved(true);
		} catch (error) {
			setHasError(true);
		} finally {
			setIsSaving(false);
		}

		// onClose();
	};

	return (
		<div
			className="client-details-overlay"
			onClick={(event) => {
				// Only close when clicking the backdrop itself (prevents accidental closes
				// when clicks bubble from inside the panel or other nested elements).
				if (event.target !== event.currentTarget) return;
				onClose();
			}}
		>
	            <FileViewerModal 
	                isOpen={viewerOpen}
	                onClose={() => {
	                    setViewerOpen(false);
	                    setSelectedFile(null);
                }}
                fileUrl={selectedFile?.url}
                fileName={selectedFile?.name}
                fileType={selectedFile?.type}
            />
			{isOpen && (
				<div className="modal">
					<div className="modal-content">
						<h2>Are you sure you want to delete this user?</h2>
						<div className="btncontainer">
							<button
								onClick={() => handleDelete(client?.id)}
								className="yesBtn"
							>
								Yes
							</button>
							<button onClick={closePopup} className="noBtn">
								No
							</button>
						</div>
					</div>
				</div>
			)}
			<aside className="details-panel" onClick={(e) => e.stopPropagation()}>
				<div className="details-number">
					<h2 className="text-2xl font-semibold ">Client details</h2>

					<div className="block-right">
						<form onSubmit={handleSubmit(onDeleteSubmit)}>
							<input type="hidden" {...register('id')} value={client?.id || ''} />

							<button type="submit" className="btn-delete-item">
								Delete Client <Trash2 size={20} />
							</button>
						</form>
						<button
							onClick={() => {
								setEditForm(!editFrom);
								setNewNoteText(''); // Clear the note textarea
							}}
							className="btn-edit-item"
						>
							{!editFrom ? (
								<>
									Edit client <Edit2 size={20} />
								</>
							) : (
								<>Cancel</>
							)}
						</button>
						<button onClick={closeSlide} className="close-btn">
							<X size={24} />
						</button>
						<div className="flex w-full items-center mt-5 ">{/* status */}</div>
					</div>
				</div>
				{editFrom ? (
					<>
						<form onSubmit={handleSubmit(onSubmit)}>
							<div className="tab-information">
								<div className="content-block">
									<div className="field-section-full">
										<label className="block text-gray-700 text-sm font-bold mb-2">
											First Name
										</label>
										<input
											type="text"
											id="firstName"
											{...register('firstName')}
											defaultValue={client?.firstName}
											className="reg-input"
										/>
										{errors.firstName && (
											<span className="error">This field is required</span>
										)}
									</div>

									<hr className="mb-5" />
									<div className="field-section-full">
										<label
											className="block text-gray-700 text-sm font-bold mb-2"
											htmlFor="lastName"
										>
											Last Name
										</label>
										<input
											className="reg-input"
											type="text"
											id="lastName"
											{...register('lastName')}
											defaultValue={client?.lastName}
										/>
										{errors.lastName && (
											<span className="error">This field is required</span>
										)}
									</div>
									<hr className="mb-5" />
									<div className="field-section-full">
										<label
											className="block text-gray-700 text-sm font-bold mb-2"
											htmlFor="companyName"
										>
											Company Name
										</label>
										<input
											className="reg-input"
											type="text"
											id="companyName"
											{...register('companyName')}
											defaultValue={client?.companyName}
										/>
										{errors.companyName && (
											<span className="error">This field is required</span>
										)}
									</div>
									<hr className="mb-5" />

									<div className="field-section-full">
										<label
											className="block text-gray-700 text-sm font-bold mb-2"
											htmlFor="email"
										>
											Email
										</label>
										<input
											className="reg-input"
											type="email"
											id="email"
											{...register('email')}
											defaultValue={client?.email}
										/>
										{errors.email && (
											<span className="error">This field is required</span>
										)}
									</div>
									<hr className="mb-5" />
									<div className="field-section-full">
										<label
											className="block text-gray-700 text-sm font-bold mb-2"
											htmlFor="phoneNumber"
										>
											Phone Number
										</label>
										<input
											className="reg-input"
											id="phoneNumber"
											type="tel"
											defaultValue={formatPhoneNumberInput(client?.phoneNumber)} // Use the state-managed phoneNumber
											onChange={(e) => {
                                                const val = e.target.value;
                                                const formatted = formatPhoneNumberInput(val);
                                                setPhoneNumber(formatted);
                                                setValue('phoneNumber', formatted); // Update react-hook-form
                                            }}
										/>
									</div>
									<hr className="mb-5" />
									<div className="field-section-full">
										<label
											className="block text-gray-700 text-sm font-bold mb-2"
											htmlFor="address"
										>
											Address
										</label>
										<input
											className="reg-input"
											type="text"
											id="address"
											{...register('address')}
											defaultValue={clientAddress.address}
										/>
										{errors.address && (
											<span className="error">This field is required</span>
										)}
									</div>
									<div className="field-section-full">
										<label
											className="block text-gray-700 text-sm font-bold mb-2"
											htmlFor="city"
										>
											City
										</label>
										<input
											className="reg-input"
											type="text"
											id="city"
											{...register('city')}
											defaultValue={clientAddress.city}
										/>
										{errors.city && (
											<span className="error">This field is required</span>
										)}
									</div>
									<div className="field-section-full">
										<label
											className="block text-gray-700 text-sm font-bold mb-2"
											htmlFor="state"
										>
											State
										</label>
										<input
											className="reg-input"
											type="text"
											id="state"
											{...register('state')}
											defaultValue={clientAddress.state}
										/>
										{errors.state && (
											<span className="error">This field is required</span>
										)}
									</div>
									<div className="field-section-full">
										<label
											className="block text-gray-700 text-sm font-bold mb-2"
											htmlFor="postalCode"
										>
											Postal Code
										</label>
										<input
											className="reg-input"
											type="text"
											id="postalCode"
											{...register('postalCode')}
											defaultValue={clientAddress.postalCode}
										/>
										{errors.postalCode && (
											<span className="error">This field is required</span>
										)}
									</div>
									{currentUser?.role === 'SUPER' && (
										<div className="field-section-full">
											<label
												className="block text-gray-700 text-sm font-bold mb-2"
												htmlFor="source"
											>
												Account Manager:
											</label>
											<select
												className="reg-input"
												id="source"
												{...register('source')}
												defaultValue={client?.source}
												onChange={(e) => setValue('source', e.target.value)}
											>
												{accountManager?.map((option) => (
													<option key={option.value} value={option.value}>
														{option.label}
													</option>
												))}
											</select>
											{errors.source && (
												<span className="error">This field is required</span>
											)}
										</div>
									)}

									<div className="field-section-full">
										<label
											className="block text-gray-700 text-sm font-bold mb-2"
											htmlFor="status"
										>
											Status
										</label>
										<select
											className="reg-input"
											id="status"
											{...register('status')}
											defaultValue={client?.status}
											onChange={(e) => setValue('status', e.target.value)}
										>
											{statusOptions?.map((option) => (
												<option key={option.value} value={option.value}>
													{option.label}
												</option>
											))}
										</select>
										{errors.status && (
											<span className="error">This field is required</span>
										)}
									</div>
									<hr className="mb-5" />

									<button type="submit" className="btn-save">
										Save
									</button>
									{isSaving && (
										<div style={{ color: 'blue' }}>Saving data...</div>
									)}
									{hasError && (
										<div style={{ color: 'red' }}>
											Error saving data. Please try again.
										</div>
									)}
									{isSaved && (
										<div style={{ color: 'green' }}>
											Data saved successfully!
										</div>
									)}
								</div>
							</div>
						</form>
					</>
				) : (
					<>
						<div className="details-client-quick-info">
							<h3>
								{client?.firstName} {client?.lastName}{' '}
							</h3>
							<p> {client?.companyName} </p>
							{/* Icons with links for email, phone and edit */}
							<div className="details-client-icons">
								{client?.email && (
									<a href={`mailto:${client?.email}`} title="Send Email">
										<Mail size={24} className="icon-item" />
									</a>
								)}
								{client?.phoneNumber && (
									<a href={`tel:${client?.phoneNumber}`} title="Call Phone">
										<PhoneOutgoing size={24} className="icon-item" />
									</a>
								)}
								<span
									onClick={() => {
										setEditForm(!editFrom);
										setNewNoteText(''); // Clear the note textarea
									}}
								>
									{!editFrom ? (
										<>
											<Edit size={24} className="icon-item" />
										</>
									) : (
										<XCircle size={24} className="icon-item" />
									)}
								</span>
								<button
									onClick={() => toggleSection('notes')}
									title="Add Note"
									className="relative"
								>
									<FileText size={24} className="icon-item" />
									{client?.notes && client.notes.length > 0 && (
										<span className="absolute top-0 right-0 inline-flex items-center justify-center px-2 py-1 text-xs font-bold leading-none text-red-100 bg-red-600 rounded-full">
											{client.notes.length}
										</span>
									)}
								</button>
								<span
									className={`ml-2 w-3 h-3 ${getStatusColor(
										client?.status
									)} rounded-full inline-block`}
								></span>
								<span className={`ml-2 text-${getStatusColor(client?.status)}`}>
									{getStatusLabel(client?.status)}
								</span>
							</div>
						</div>
						<div className="user-information">
							<div className="user-information-block">
								<div
									className="title-block"
									onClick={() => toggleSection('info')}
								>
									<h2 className="title-h2">Client Information</h2>
									<button>
										{sections.info ? (
											<ChevronDown size={24} />
										) : (
											<ChevronRight size={24} />
										)}
									</button>
								</div>
								{sections.info && (
									<div className="grid grid-flow-row-dense grid-cols-2 grid-rows-2 content-block">
										<p className="data-content">
											<strong>First Name:</strong> {client?.firstName}
										</p>
										<p className="data-content">
											<strong>Last Name:</strong> {client?.lastName}
										</p>
										<p className="data-content">
											<strong>Company Name:</strong> {client?.companyName}
										</p>
										<p className="data-content">
											<strong>Email:</strong> {client?.email}
										</p>
										<p className="data-content">
											<strong>Phone Number:</strong>{' '}
											{client?.phoneNumber
												? formatPhoneNumber(client?.phoneNumber)
												: 'N/A'}
										</p>

										<p className="data-content">
											<strong>User Created: </strong>{' '}
											{new Date(client?.createdAt).toLocaleString('en-US', {
												month: '2-digit',
												day: '2-digit',
												year: '2-digit',
												hour: '2-digit',
												minute: '2-digit',
											})}
										</p>
									</div>
								)}
							</div>
						</div>
						<div className="user-information">
							<div className="user-information-block">
								<div
									className="title-block"
									onClick={() => toggleSection('address')}
								>
									<h2 className="title-h2">Client Address</h2>
									<button>
										{sections.address ? (
											<ChevronDown size={24} />
										) : (
											<ChevronRight size={24} />
										)}
									</button>
								</div>
								{sections.address && (
									<div className="grid grid-flow-row-dense grid-cols-2 grid-rows-2 content-block">
										<p className="data-content">
											<strong>Street:</strong> {clientAddress.address}
										</p>
										<p className="data-content">
											<strong>City:</strong> {clientAddress.city}
										</p>
										<p className="data-content">
											<strong>State:</strong> {clientAddress.state}
										</p>
										<p className="data-content">
											<strong>Zipcode:</strong> {clientAddress.postalCode}
										</p>
									</div>
								)}
							</div>
						</div>
						<div className="user-information">
							<div className="user-information-block">
								<div
									className="title-block"
									onClick={() => toggleSection('notes')}
								>
									<h2 className="title-h2">Notes</h2>
									<button>
										{sections.notes ? (
											<ChevronDown size={24} />
										) : (
											<ChevronRight size={24} />
										)}
									</button>
								</div>
								{sections.notes && (
									<div className="content-block p-4">
										{/* New Note Form */}
										<div className="bg-white rounded-lg mb-6">
											<form ref={formRef} onSubmit={handleSubmit(onSubmitFile)}>
												<div className="mb-3">
													<textarea
														placeholder="Type your note here..."
														className="w-full p-3 border border-slate-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 min-h-[100px] text-sm"
														{...register('textNote', { required: true })}
													/>
													{errors.textNote && (
														<span className="text-red-500 text-xs mt-1 block">
															This field is required
														</span>
													)}
												</div>
												<div className="space-y-2 mb-4">
													{fileInputs.map((index, i) => (
														<div
															key={`${index}-${i}`}
															className="flex items-center gap-2"
														>
															<input
																type="file"
																name="file"
																className="block w-full text-sm text-slate-500
                                                                    file:mr-4 file:py-2 file:px-4
                                                                    file:rounded-full file:border-0
                                                                    file:text-sm file:font-semibold
                                                                    file:bg-blue-50 file:text-blue-700
                                                                    hover:file:bg-blue-100 cursor-pointer"
																onChange={(e) => {
																	if (e.target.files.length > 0) {
																		fileUploadHandler(e.target.files[0]);
																	}
																}}
															/>
														</div>
													))}
												</div>

												<div className="flex items-center justify-between">
													<div className="flex gap-2">
														<button
															type="button"
															onClick={addFileInput}
															className="flex items-center gap-1 text-sm text-blue-600 hover:text-blue-800"
														>
															<PlusCircle size={16} />
															<span>Add File</span>
														</button>
														{fileInputs.length > 1 && (
															<button
																type="button"
																onClick={removeFileInput}
																className="flex items-center gap-1 text-sm text-red-500 hover:text-red-700"
															>
																<X size={16} />
																<span>Remove</span>
															</button>
														)}
													</div>

													<button
														type="submit"
														className="px-6 py-2 bg-blue-600 text-white text-sm font-medium rounded-md hover:bg-blue-700 transition-colors shadow-sm"
													>
														Save Note
													</button>
												</div>
												{Msg && (
													<div className="mt-2 text-green-600 text-sm font-medium">
														{Msg}
													</div>
												)}
												{progress.started && (
													<div className="w-full bg-gray-200 rounded-full h-2.5 mt-2">
														<div
															className="bg-blue-600 h-2.5 rounded-full"
															style={{ width: `${progress.pc}%` }}
														></div>
														<span className="text-xs text-gray-500 mt-1 block">
															{progress.msg}
														</span>
													</div>
												)}
											</form>
										</div>

										<div className="border-t border-slate-200 my-6"></div>

										{/* Notes List */}
										<div className="space-y-4">
											<h3 className="text-sm font-bold text-slate-700 uppercase tracking-wide mb-3">
												Previous Notes
											</h3>
											{client?.notes && client.notes.length > 0 ? (
												[...client.notes].reverse().map((note, index) => (
													<div
														key={index}
														className="bg-slate-50 border border-slate-200 rounded-lg p-4 shadow-sm relative group hover:bg-slate-100 transition-colors"
													>
														<div className="flex justify-between items-start mb-2">
															<div className="flex items-center gap-2">
																<div className="w-8 h-8 rounded-full bg-blue-100 flex items-center justify-center text-blue-600 font-bold text-xs uppercase">
																	{note?.userId
																		? getUserName(note?.userId).charAt(0)
																		: 'U'}
																</div>
																<div>
																	<p className="text-sm font-semibold text-slate-900">
																		{note?.userId
																			? getUserName(note?.userId)
																			: 'Unknown User'}
																	</p>
																	{/* Optional: Add role here if available */}
																</div>
															</div>
															<span className="text-xs text-slate-500 whitespace-nowrap">
																{new Date(note?.createdAt).toLocaleString(
																	'en-US',
																	{
																		month: 'short',
																		day: 'numeric',
																		year: 'numeric',
																		hour: 'numeric',
																		minute: '2-digit',
																	}
																)}
															</span>
														</div>

														<div className="text-sm text-slate-700 whitespace-pre-wrap pl-10">
															{note?.text}
														</div>

														{note?.attachments?.length > 0 && (
															<div className="mt-3 pl-10 flex flex-wrap gap-2">
																{note.attachments.map((file, i) => (
																	<button
																		key={i}
																		type="button"
																		onClick={(e) => {
																			e.preventDefault();
                                                                            setSelectedFile({
                                                                                url: file.url,
                                                                                name: file.description || `Attachment ${i + 1}`,
                                                                                type: file.type
                                                                            });
                                                                            setViewerOpen(true);
																		}}
																		className="flex items-center gap-2 px-3 py-1.5 bg-white border border-slate-300 rounded text-xs text-slate-600 hover:text-blue-600 hover:border-blue-400 transition-colors shadow-sm"
																		title={file.description || "View Attachment"}
																	>
																		<FileText size={14} />
																		<span className="truncate max-w-[200px]">
																			{file.description || `Attachment ${i + 1}`}
																		</span>
																	</button>
																))}
															</div>
														)}
													</div>
												))
											) : (
												<p className="text-slate-400 text-sm text-center py-4 italic">
													No notes added yet.
												</p>
											)}
										</div>
									</div>
								)}
							</div>
						</div>
					</>
				)}
			</aside>
		</div>
	);
}
